import { CSSObject } from '@chakra-ui/react';

export const buttonIncreaseProps: CSSObject = {
  variant: 'odds',
  fontWeight: 'normal',
  fontFamily: 'accent',
};
